var $0ed2db6e68f48ea3$exports = {};
$0ed2db6e68f48ea3$exports = {
  "collapse": "D\xF6lj",
  "expand": "Expandera"
};
export { $0ed2db6e68f48ea3$exports as default };